(() => {
  const storageKey = 'platespec-builder-start-v1';
  const starter = document.querySelector('[data-ps-starter]');
  if (starter) {
    const registration = starter.querySelector('[name="registration"]');
    registration.addEventListener('input', () => { registration.value = registration.value.toUpperCase(); });
    starter.addEventListener('submit', (event) => {
      if (!starter.reportValidity()) return;
      event.preventDefault();
      const data = new FormData(starter);
      const entry = { registration: String(data.get('registration')).trim().toUpperCase(), plates: data.get('plates'), sizeChoice: data.get('size_choice'), created: Date.now() };
      const destination = new URL(starter.action, location.origin);
      try { sessionStorage.setItem(storageKey, JSON.stringify(entry)); }
      catch { destination.searchParams.set('registration', entry.registration); destination.searchParams.set('plates', entry.plates); destination.searchParams.set('size_choice', entry.sizeChoice); }
      location.assign(destination.href);
    });
  }
  document.querySelectorAll('[data-ps-gallery]').forEach((gallery) => {
    const wrapper = gallery.parentElement;
    const controls = wrapper.querySelectorAll('[data-gallery-direction]');
    const update = () => { controls.forEach(button => { button.hidden = gallery.scrollWidth <= gallery.clientWidth + 2; }); };
    controls.forEach(button => button.addEventListener('click', () => {
      const amount = (gallery.firstElementChild?.getBoundingClientRect().width || 200) + 12;
      const direction = Number(button.dataset.galleryDirection);
      const atEnd = gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 2;
      const atStart = gallery.scrollLeft <= 2;
      gallery.scrollTo({ left: direction > 0 && atEnd ? 0 : direction < 0 && atStart ? gallery.scrollWidth : gallery.scrollLeft + direction * amount, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }));
    new ResizeObserver(update).observe(gallery);
    update();
  });
  if (!['/pages/build-your-plates','/products/platespec-number-plates'].includes(location.pathname)) return;
  let entry;
  try { entry = JSON.parse(sessionStorage.getItem(storageKey)); } catch { /* URL fallback below. */ }
  if (entry && Date.now() - entry.created > 10 * 60 * 1000) { try { sessionStorage.removeItem(storageKey); } catch {} entry = null; }
  if (!entry) {
    const query = new URLSearchParams(location.search);
    if (query.has('registration')) entry = { registration: query.get('registration'), plates: query.get('plates'), sizeChoice: query.get('size_choice') };
  }
  if (!entry || !/^[A-Z0-9 ]{1,12}$/i.test(entry.registration || '')) return;
  let attempts = 0;
  const apply = () => {
    const app = document.querySelector('platespec-configurator');
    const root = app?.shadowRoot;
    const input = root?.getElementById('registration');
    const choice = root?.querySelector(`#plates [data-option-id="${['pair', 'front', 'rear'].includes(entry.plates) ? entry.plates : 'pair'}"]`);
    if (!input || !choice) {
      if (++attempts < 240) setTimeout(apply, 250);
      return;
    }
    input.value = entry.registration.toUpperCase();
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('blur', { bubbles: true, composed: true }));
    root.querySelector(`#plates [data-option-id="${['pair', 'front', 'rear'].includes(entry.plates) ? entry.plates : 'pair'}"]`)?.click();
    if (entry.sizeChoice === 'shortened') root.getElementById('size')?.scrollIntoView({ block: 'center' });
    try { sessionStorage.removeItem(storageKey); } catch {}
  };
  apply();
})();
